// const API_BASE_URL = "http://localhost/phpValidation/charity";
const API_BASE_URL = "https://charitycms.gudstart.com/api";


const apiEndpoints = {
  oruCauses: `${API_BASE_URL}/ourcauses.php`,
  donate: `${API_BASE_URL}/donate.php`,
  gallery: `${API_BASE_URL}/gallery.php`,
  volunteer: `${API_BASE_URL}/volunteer.php`,
  termsconditions: `${API_BASE_URL}/termsconditions.php`,
  refundpolicy: `${API_BASE_URL}/refundpolicy.php`,
  events: `${API_BASE_URL}/events.php`,
  dashboard: `${API_BASE_URL}/dashboard.php`,
  auth: `${API_BASE_URL}/auth.php`,
  Privacypolicy: `${API_BASE_URL}/privacypolicy.php`,


  idproof_path: `${API_BASE_URL}/`,
  
};

export default apiEndpoints;